import {
  BotConversationInterface,
  BotConversationListItem,
  BotLLMCallInterface,
  BotMessageInterface,
  BotUserAnalyticsEventInterface
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

interface PaginatedConversationList {
  data: BotConversationListItem[];
  pagination: { nextCursor: string | null; hasNext: boolean };
}

interface ListParams {
  status?: string;
  channel?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
  after?: string;
  limit?: number;
}

export class BotConversationsAPI {
  static async getConversations(orgId: number, params?: ListParams): Promise<PaginatedConversationList> {
    const query: Record<string, any> = {};
    if (params?.status) query.status = params.status;
    if (params?.channel) query.channel = params.channel;
    if (params?.startDate) query.startDate = params.startDate;
    if (params?.endDate) query.endDate = params.endDate;
    if (params?.search) query.search = params.search;
    if (params?.after) query.after = params.after;
    if (params?.limit) query.limit = params.limit;
    return APIService.Server.get<PaginatedConversationList>(`/bot-conversations/org/${orgId}`, query);
  }

  static async getConversation(orgId: number, id: number): Promise<BotConversationInterface> {
    return APIService.Server.get<BotConversationInterface>(`/bot-conversations/org/${orgId}/conversation/${id}`);
  }

  static async getMessages(orgId: number, conversationId: number, includeInvisible?: boolean): Promise<BotMessageInterface[]> {
    const params: Record<string, any> = {};
    if (includeInvisible) params.includeInvisible = true;
    return APIService.Server.get<BotMessageInterface[]>(`/bot-conversations/org/${orgId}/conversation/${conversationId}/messages`, params);
  }

  static async getLLMCalls(orgId: number, conversationId: number): Promise<BotLLMCallInterface[]> {
    return APIService.Server.get<BotLLMCallInterface[]>(`/bot-conversations/org/${orgId}/conversation/${conversationId}/llm-calls`);
  }

  static async getAnalyticsEvents(orgId: number, conversationId: number): Promise<BotUserAnalyticsEventInterface[]> {
    return APIService.Server.get<BotUserAnalyticsEventInterface[]>(`/bot-conversations/org/${orgId}/conversation/${conversationId}/analytics-events`);
  }
}
